import { render, staticRenderFns } from "./EventSpeakerCard.vue?vue&type=template&id=8ce37f84&"
import script from "./EventSpeakerCard.vue?vue&type=script&lang=js&"
export * from "./EventSpeakerCard.vue?vue&type=script&lang=js&"
import style0 from "./EventSpeakerCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports